import z from 'zod';

import { basicResponseSchema } from 'services/idm/shared/schemas/basic-response.schema';
import {
	formFieldSchema,
	formFieldValueSchema,
} from 'services/idm/shared/schemas/idm-form-fields.schema';

/** Full field metadata for form state and client-side validation. */
export const postRegisterAdditionalInfoRequestSchema = z.object({
	fields: z.array(formFieldSchema),
});

/** Alias/value pairs sent to the register/additional-info POST endpoint. */
export const postRegisterAdditionalInfoPayloadSchema = z.object({
	fields: z.array(formFieldValueSchema),
});

export const postRegisterAdditionalInfoResponseSchema = basicResponseSchema;
